import React from "react";
import style from "../assets/scss/components/loading-spinner.module.scss";
import { ReactComponent as Spinner } from "../assets/icons/loading-spinner.svg";

export default function LoadingSpinner() {
  return <Spinner className={style["spinner"]} />;
}
